import {getApi} from "../../data/ApiService";


const state ={
    products:{},
    loading: false,
    error: false,
    searchProducts:{}
}

const actions={
    async getProducts({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('categories/8');
            commit('setProducts', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    clearSearch({commit,state}){
        state.searchProducts={};
    },
    async searchProducts({commit,state},payload) {
        // commit('setLoading', true);
        try {
            const response = await getApi('topics/12/page/1/count/100?q='+payload.q,{},false);
            state.searchProducts=response.data;
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            // commit('setLoading', false);
        }
    },
}

const mutations ={
    setProducts(state,response){
        state.products = response.data.categories;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setError(state, error) {
        state.error = error;
    }
}

const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}